const state = {
  newUrl: 'report/get_report',
  newExcelUrl: 'report/get_report_excel',
  url: 'ats/get_report_data', // 'report/get_report',
  excelUrl: 'ats/get_report_excel_data', // 'report/get_report_excel'
}

const mutations = {
}

const getters = {
  newReportUrl () {
    return state.newUrl
  },
  reportUrl () {
    return state.url
  },
  reportExcelUrl () {
    return state.excelUrl
  },
  newReportExcelUrl () {
    return state.newExcelUrl
  }
}

export default {
  state,
  mutations,
  getters
}
